import { ReactComponent as NewsletterImage } from "assets/images/newsletter.svg";
import ContentContainer from "components/ContentContainer";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

interface ContainerProps {
  isOnScreen: boolean;
}

export const StyledContentContainer = styled(ContentContainer)`
  @media (max-width: ${breakpoints.lg}) {
    width: 90%;
  }

  @media (max-width: ${breakpoints.md}) {
    width: 100%;
  }
`;

export const Container = styled.div<ContainerProps>`
  position: absolute;
  display: flex;
  z-index: 99;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.light};
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);

  @media (min-width: ${breakpoints.md}) {
    transform: translateY(${({ isOnScreen }) => (isOnScreen ? 0 : "20%")});
    opacity: ${({ isOnScreen }) => (isOnScreen ? 1 : 0)};
    transition: transform 1s 0.5s, opacity 1s 0.5s;
  }

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;
  }
`;

export const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 40px;

  @media (max-width: ${breakpoints.md}) {
    position: absolute;
    box-sizing: border-box;
    left: 0;
    padding: 0;
    width: 100%;
    transform: translateY(-55%);
  }
`;

export const StyledNewsletterImage = styled(NewsletterImage)`
  width: 100%;
  max-height: 200px;
`;

export const FormContainer = styled.div`
  width: 60%;

  @media (max-width: ${breakpoints.md}) {
    width: 100%;
    margin-top: 100px;
  }
`;
